"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FieldValidator = void 0;
const _ = require("lodash");
const validator_1 = require("./validator");
const buildValidationDefinition_1 = require("./helpers/buildValidationDefinition");
/**
 * Validates a field based on its description. For multi-value fields, any field-level errors
 * are provided at index 0. All value-based errors are provided there after.
 *
 * @param field
 * @returns {Promise<*>}
 */
const FieldValidator = async (field, client) => {
    // maps our field description to one understood by validator.js
    const constraints = (0, buildValidationDefinition_1.default)(field, client);
    // field-level checks for multi-values
    if (field.allowMultiple) {
        // presence for a multi-value field requires checking it has at least one value
        if (constraints.presence && field.value.length === 0) {
            return [["Please provide at least one value"]];
        }
    }
    async function validateData(value) {
        try {
            await validator_1.default.async({
                theValue: value
            }, {
                theValue: constraints
            });
        }
        catch (e) {
            console.error("Error during validation, check FieldValidator", e);
            return e.theValue;
        }
    }
    const presenceError = validator_1.default.single(field.allowMultiple ? _.first(field.value) : field.value, {
        presence: {
            allowEmpty: false
        }
    });
    const isPresent = _.isUndefined(presenceError);
    // skip validation if not required and not present
    if (constraints.presence || isPresent) {
        if (field.allowMultiple) {
            // first slot is reserved for field-level errors
            return Promise.all(field.value.map((value) => validateData(value))).then(errors => [null].concat(errors));
        }
        return validateData(field.value);
    }
};
exports.FieldValidator = FieldValidator;
// TODO - legacy support
exports.default = exports.FieldValidator;
//# sourceMappingURL=index.js.map